import { render, staticRenderFns } from "./CostumerRelation.vue?vue&type=template&id=8ea165fa&"
import script from "./CostumerRelation.vue?vue&type=script&lang=js&"
export * from "./CostumerRelation.vue?vue&type=script&lang=js&"
import style0 from "./CostumerRelation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports